// extracted by mini-css-extract-plugin
module.exports = {"title":"playerNewsHeader_title__ezq7c","filterContainer":"playerNewsHeader_filterContainer__pvwNL","container":"playerNewsHeader_container__xUoE6"};